/**
 * The Abridge mark + wordmark, lifted verbatim from the Claude Design mock's
 * sidebar SVG paths. `currentColor` keeps them tinted by the parent, exactly as
 * the mock does.
 */
export function AbridgeWordmark() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
        style={{ width: 24, height: 24, flex: '0 0 auto' }}
      >
        <path
          d="M31.0748 31.3101H27.5306L24.5571 24.699C23.0493 21.2915 19.6691 19.1017 15.9214 19.1017C12.1737 19.1017 8.83279 21.2915 7.32637 24.699L4.35289 31.3101H0.808594L7.6518 16.0195H24.2316L31.0748 31.3101ZM11.1961 16.0195H7.6518L14.4963 0.729004H17.3884L24.2316 16.0195H20.6873L15.9621 5.43389L11.1961 16.0195Z"
          fill="currentColor"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="16 24 92 16"
        fill="none"
        aria-label="Abridge"
        style={{ width: 92, height: 16, flex: '0 0 auto' }}
      >
        <path
          d="M31.1331 39.6453H29.361L27.8742 36.3397C27.1204 34.636 25.4302 33.5411 23.5564 33.5411C21.6825 33.5411 20.0121 34.636 19.2589 36.3397L17.7721 39.6453H16L19.4216 32H27.7115L31.1331 39.6453ZM21.1937 32H19.4216L22.8439 24.3547H24.2899L27.7115 32H25.9394L23.5767 26.7072L21.1937 32Z"
          fill="currentColor"
        />
        <path
          d="M43.1945 31.9997H33.1331V24.3544H37.8177C39.7729 24.3544 41.5654 25.936 41.7078 27.8834C41.7892 28.9378 41.4427 29.8909 40.8319 30.6213C41.7485 30.8649 42.5634 31.3516 43.1945 32.0003V31.9997ZM44.5186 35.0622C44.5186 37.5767 42.4413 39.6456 39.895 39.6456H33.1331V32.0003H34.7832V38.1045H39.7329C41.444 38.1045 42.7878 36.7255 42.7878 35.042C42.7878 33.5211 41.3417 32.1218 39.6712 32.0003H43.1945C44.0094 32.8319 44.5186 33.9066 44.5186 35.0629V35.0622ZM37.6747 25.8955H37.0639C35.7805 25.8955 34.7622 26.8891 34.7622 28.1669C34.7622 29.4447 35.7805 30.4586 37.0639 30.4586H37.6137C38.8767 30.4586 39.9357 29.5257 39.9763 28.2682C40.017 26.9499 38.9987 25.8955 37.6747 25.8955Z"
          fill="currentColor"
        />
        <path
          d="M52.9753 24.3544C55.0322 24.3544 56.845 26.0379 56.8857 28.0859C56.9264 30.2358 55.1949 31.9997 53.0567 31.9997H46.5186V24.3544H52.9753ZM48.1687 39.6456H46.5186V32.0003H48.1687V39.6456ZM52.7923 30.4586C54.0349 30.4586 55.0939 29.5257 55.1549 28.2884C55.2159 26.9904 54.1773 25.8955 52.8736 25.8955H50.45C49.1666 25.8955 48.1483 26.9296 48.1483 28.1872C48.1483 29.4447 49.1666 30.4586 50.45 30.4586H52.7923ZM57.0491 39.6456H55.1956L51.0405 32.0003H52.9346L57.0491 39.6456Z"
          fill="currentColor"
        />
        <path
          d="M63.5506 27.2141V32H61.9005V27.2141C61.9005 26.4838 61.2897 25.8958 60.5562 25.8958H59.0491V24.3547H66.4021V25.8958H64.895C64.1411 25.8958 63.5506 26.4838 63.5506 27.2141ZM61.9005 36.7859V32H63.5506V36.7859C63.5506 37.5163 64.1411 38.1244 64.895 38.1244H66.4021V39.6453H59.0491V38.1244H60.5562C61.2897 38.1244 61.9005 37.5163 61.9005 36.7859Z"
          fill="currentColor"
        />
        <path
          d="M72.5979 24.3544C77.4452 24.3544 80.8878 27.579 80.8878 31.9997H79.1564C79.1564 28.4707 76.5903 25.8955 72.5979 25.8955H70.0522V31.9997H68.4021V24.3544H72.5979ZM72.5979 39.6456H68.4021V32.0003H70.0522V35.5698C70.0522 36.9691 71.1925 38.1045 72.5979 38.1045C76.5897 38.1045 79.1564 35.5293 79.1564 32.0003H80.8878C80.8878 36.421 77.4459 39.6456 72.5979 39.6456Z"
          fill="currentColor"
        />
        <path
          d="M96.6162 26.3113L95.4346 27.5081C94.2943 26.3524 92.7052 25.6423 90.9127 25.6423C87.3277 25.6423 84.6193 28.441 84.6193 32.0105H82.8878C82.8878 27.4878 86.4525 24 90.9127 24C93.1533 24 95.1695 24.8721 96.6156 26.3119L96.6162 26.3113ZM97.105 37.2216C95.659 38.9861 93.4387 40 90.9133 40C86.4531 40 82.8885 36.5324 82.8885 32.0098H84.62C84.62 35.5995 87.329 38.3577 90.9133 38.3577C93.1539 38.3577 95.0685 37.283 95.9851 35.7211C96.4942 34.8489 96.1071 33.5509 95.0481 33.5509H90.2618V32.0098H98.7958C98.7958 34.2205 98.2257 35.8426 97.105 37.2216Z"
          fill="currentColor"
        />
        <path
          d="M100.796 32V24.3547H107.089V25.8958H104.747C103.423 25.8958 102.445 26.8489 102.445 28.1672C102.445 29.4855 103.423 30.4589 104.747 30.4589H107.089V32H100.796ZM100.796 39.6453V32H102.446V38.1042H107.09V39.6453H100.796Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
